import { PageLayoutProps } from './PageLayout.types'
import { DEFAULT_THEME_COLORS } from './PageLayout.data'

export function isValidTheme(theme: PageLayoutProps['theme']) {
  if (!theme) return false

  return (
    theme.primaryColor !== DEFAULT_THEME_COLORS.PRIMARY ||
    theme.secondaryColor !== DEFAULT_THEME_COLORS.SECONDARY ||
    theme.textColor !== DEFAULT_THEME_COLORS.TEXT
  )
}
